import { render } from "./Layout.vue?vue&type=template&id=4e3494ec"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
script.render = render

export default script